import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import dedent from 'dedent';

export default createPerformableConfig(
  'dusk',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      quantity: z.coerce
        .number({ invalid_type_error: 'Quantity is required' })
        .positive({ message: 'Quantity must be greater than zero' })
    }),
  },
  {
    name: 'Digital Day to Dusk Photo Edit',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/dusk/thumbnail.jpg',
    images: [],
    short: dedent`
      Digital day-to-dusk photo editing is a cost-effective way to daytime \
      property photos into stunning twilight images with warm lighting and vibrant sunset \
      skies. This technique enhances a home’s appeal by creating a welcoming, atmospheric \
      look without requiring an evening photoshoot. Unlike traditional twilight photography, \
      which depends on precise timing, ideal weather, and higher costs, digital editing offers \
      flexibility, consistency, and dramatic results. By showcasing a property’s best features \
      in an eye-catching way, it becomes a valuable tool for real estate marketing.
    `,
  },
);
